import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="notification"
export default class extends Controller {
  connect() {
    this.timeout = setTimeout(() => {
      this.remove();
    }, 2000);
  }

  disconnect() {
    this.clearTimeout();
  }

  close(event) {
    event.preventDefault();
    this.remove();
  }

  remove() {
    this.clearTimeout();
    this.element.remove();
  }

  clearTimeout() {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = null;
  }
}
